/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { filter, map } from 'lodash';
import { show } from 'redux-modal';
import { toast } from 'react-toastify';
import DropdownMenu from '../DropdownMenu/DropdownMenu';
import { getSpotsByLot, deleteSpot } from '../../actions/parkingSpotActions';
import { Button } from '../utils/forms/Button';
import { deleteLot } from '../../actions/parkingLotActions';

function RollBox({ id: lotId }) {
  const dispatch = useDispatch();
  const [rolled, setRoll] = useState(false);
  const lot = useSelector((state) => state.lots[lotId]);
  const spots = useSelector((state) =>
    filter(state.spots, (spot) => spot.parkingLotId === lotId)
  );

  const items = [
    {
      text: 'Upravit',
      action: () => {
        dispatch(show('editParkingLotModal', { id: lot.id }));
      }
    },
    {
      text: 'Smazat',
      action: () => {
        dispatch(deleteLot(lotId))
          .then(() => {
            toast.warn('Smazali jste parkoviště');
          })
          .catch((err) => {});
      }
    }
  ];

  useEffect(() => {
    dispatch(getSpotsByLot(lotId));
  }, []);

  function handleToggle() {
    setRoll(!rolled);
  }

  function openAddSpot() {
    dispatch(show('newParkingSpotModal', { lotId: lot.id }));
  }

  function handleSharePlace(e, id) {
    e.preventDefault();
    dispatch(show('sharePermanentPlaceModal', { spotId: id }));
  }

  function openEditSpotModal(e, id) {
    e.preventDefault();
    dispatch(show('editParkingSpotModal', { id }));
  }

  function handleDeleteSpot(e, id) {
    e.preventDefault();
    dispatch(deleteSpot(id))
      .then(() => {
        toast.warn('Smazali jste parkovací místo');
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }

  return (
    <div key={lot.id} className={`rollbox${rolled ? ' rolled' : ''}`}>
      <div className="rollbox__header">
        <div className="clearfix">
          <div className="sm-col sm-col-5">
            <i className="fas fa-map-pin" /> <strong>{lot.name}</strong>{' '}
          </div>
          <div className="sm-col sm-col-5">
            <span className="light">{lot.street}</span>
          </div>
          <div className="sm-col sm-col-2">
            <DropdownMenu className="right" items={items} />
            <span className="rollbox__toggle" onClick={handleToggle} />
          </div>
        </div>
      </div>
      <div className="rollbox__body">
        <table>
          <thead>
            <tr>
              <th className="pl2">číslo</th>
              <th>patro</th>
              <th>vlastník místa</th>
              <th className="pr2" style={{ width: 65 }}>
                <Button color="secondary" size="xs" onClick={openAddSpot}>
                  přidat
                </Button>
              </th>
            </tr>
          </thead>
          <tbody>
            {map(spots, (spot) => (
              <tr key={spot.placeId}>
                <td className="pl2">{spot.place}</td>
                <td>{spot.floor}</td>
                <td>{spot.permanentUserName}</td>
                <td className="pr2 center icons">
                  <a
                    href="#"
                    onClick={(e) => openEditSpotModal(e, spot.placeId)}
                  >
                    <i className="far fa-edit mr1" />
                  </a>
                  <a
                    href="#"
                    onClick={(e) => handleDeleteSpot(e, spot.placeId)}
                  >
                    <i className="far fa-trash-alt" />
                  </a>
                  <a
                    href="#"
                    onClick={(e) => handleSharePlace(e, spot.placeId)}
                  >
                    <i className="far fa-share-square ml1" />
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default RollBox;
